import React from "react";
import { IMultipleEvent } from "../../../../redux/leads/leads.types";
import { Dialog } from "../../../../components/Dialogs/Dialog";
import { useFormik } from "formik";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { EventTimeAutoSearch } from "../../../../components/AutoCompleteSearches/EventTimeAutoSearch";
import { CustomDatePicker } from "../../../../components/formsComponents/CustomDatePicker";
import { VenueAutoSearch } from "../../../../components/AutoCompleteSearches/VenueAutoSearch";
import { ControlledCustomSelect } from "../../../../components/formsComponents";
import { useEventChangeDetector } from "./useEventChangeDetector";
import { CancelOutlined, CheckCircleOutline } from "@mui/icons-material";
import { useTimezoneFormatter } from "../../../../hooks/useTimezoneFormatter";
import { Inventory } from "../../../Inventory/Inventory";
import { EventDatePicker } from "../EventDatePicker/EventDatePicker";

interface IEventPostponedDialogProps {
  open: boolean;
  data: IMultipleEvent;
  onSaveSuccess: (update: IMultipleEvent) => void;
  onClose: () => void;
}
export const EventPostponedDialog = ({
  open,
  data,
  onSaveSuccess,
  onClose,
}: IEventPostponedDialogProps) => {
  const { ftDate } = useTimezoneFormatter();

  const [openInventory, setOpenInventory] =
    React.useState<IMultipleEvent | null>(null);

  const { values, errors, isValid, setValues, handleSubmit, setSubmitting } =
    useFormik<IMultipleEvent>({
      initialValues: {
        ...data,
      },
      validateOnChange: true,
      validate: (values) => {
        const errors: any = {};

        if (!values.event_time) {
          errors.event_time = "Event time is required";
        }

        if (!values.preferred_venue_uuid) {
          errors.preferred_venue_uuid = "Preferred venue is required";
        }

        if (!values.function_date) {
          errors.function_date = "Function date is required";
        }

        // if (!values.function_month) {
        //   errors.function_month = "Function month is required";
        // }
        return errors;
      },
      onSubmit: async (values) => {
        setSubmitting(true);
        onSaveSuccess(values);
      },
    });

  const state = useEventChangeDetector(data, values);

  return (
    <>
      <Dialog
        open={open}
        title={"Reschedule Event"}
        onClose={onClose}
        size="sm"
        contentWrappedWithForm={{ onSubmit: handleSubmit }}
        actions={[
          {
            type: "button" as const,
            label: "Cancel",
            variant: "text" as const,
            onClick: onClose,
          },
          {
            type: "button" as const,
            label: "Open Calender",
            variant: "contained" as const,
            onClick: () => {
              setOpenInventory({ ...values });
            },
          },
          {
            type: "submit" as const,
            label: "Apply Changes",
            variant: "contained" as const,
            disabled:
              !isValid || !(state.checked && state.availabilty === true),
          },
        ]}
      >

      
        <Grid container spacing={2}>
            <Grid item xs={12}>
            <CustomDatePicker
              placeholder="Event Date"
              fullWidth
              value={values.function_date || null}
              onChange={(newValue) => {
                let extractedMonth = "";
                if (newValue) {
                  const date = new Date(newValue);
                  extractedMonth = date.toLocaleString("default", {
                    month: "long",
                  });
                }
                setValues((prev) => ({
                  ...prev,
                  function_date: newValue,
                  function_month: extractedMonth,
                }));
              }}
              error={!!errors.function_date}
            />
          {/* <EventDatePicker
            value={values.function_date || null}
            disabled={values.show_month_picker}
            onChange={(newValue) => {
              setValues((prev) => ({
                ...prev,
                function_date: newValue,
              }))
            }}
            error={errors.function_date}
            event={values}
            onEventChenge={(newEvt) => {
              setValues((prev) => ({
                ...prev,
                function_date: newEvt.function_date,
                event_time_uuid: newEvt.event_time_uuid,
                event_time: newEvt.event_time,
                preferred_venue_uuid: newEvt.preferred_venue_uuid,
                preferred_venue: newEvt.preferred_venue,
              }))
            }}
            isDateNotConfirmed={values.show_month_picker}
            onDateNotConfirmChange={(newCheck) => {
              if (newCheck) {
                setValues((prev) => ({
                  ...prev,
                  show_month_picker: true,
                  function_date: "",
                  function_month: "",
                }))
              } else {
                setValues((prev) => ({
                  ...prev,
                  show_month_picker: false,
                  function_date: "",
                  function_month: "",
                }))
              }
            }}
          /> */}
        </Grid>

        {/* Event Month */}
        {values.show_month_picker && 
        <Grid item xs={12}>
          <ControlledCustomSelect
            label="Event Month"
            error={!!errors.function_date}
            helperText={errors.function_date}
            variant="outlined"
            size="small"
            type="string"
            name="function_month"
            fullWidth
            value={values.function_month || null}
            disabled
            displayEmpty
            options={[
              { label: "January", value: "January" },
              { label: "February", value: "February" },
              { label: "March", value: "March" },
              { label: "April", value: "April" },
              { label: "May", value: "May" },
              { label: "June", value: "June" },
              { label: "July", value: "July" },
              { label: "August", value: "August" },
              { label: "September", value: "September" },
              { label: "October", value: "October" },
              { label: "November", value: "November" },
              { label: "December", value: "December" },
            ]}
          />
        </Grid>
        }
        
          {/* Event Time */}
          <Grid item xs={12}>
            <EventTimeAutoSearch
              label="Event Time"
              fullWidth
              event_timing_uuid={values.event_time_uuid}
              event_name={values.event_time}
              // disabled
              value={{
                event_timing_uuid: values.event_time_uuid,
                event_name: values.event_time,
              }}
              onSelect={(newValue: any) => {
                setValues((prev) => ({
                  ...prev,
                  event_time_uuid: newValue.event_timing_uuid ?? "",
                  event_time: newValue.event_name ?? "",
                }));
              }}
              error={errors.preferred_venue_uuid}
            />
          </Grid>
          {/* Preferred Venue */}
          <Grid item xs={12}>
            <VenueAutoSearch
              label="Preferred Venue"
              venue_uuid={values.preferred_venue_uuid || undefined}
              venue_name={values.preferred_venue || undefined}
              // disabled
              value={{
                venue_uuid: values.preferred_venue_uuid,
                venue_name: values.preferred_venue,
              }}
              onSelect={(newValue: any) => {
                setValues((prev) => ({
                  ...prev,
                  preferred_venue_uuid: newValue.venue_uuid ?? "",
                  preferred_venue: newValue.venue_name ?? "",
                }));
              }}
              error={errors.preferred_venue_uuid}
            />
          </Grid>


          <Grid item xs={12}>
            {state.checked && state.availabilty === true ? (
              <Paper
                elevation={0}
                sx={{
                  mt: 2,
                  p: 2,
                  borderRadius: 2,
                  border: 2,
                  borderColor: "success.light",
                  bgcolor: "rgba(46, 125, 50, 0.08)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    bgcolor: "rgba(46, 125, 50, 0.15)",
                  }}
                >
                  <CheckCircleOutline
                    sx={{
                      color: "success.main",
                      fontSize: 24,
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    color={"success.main"}
                  >
                    Venue Available!
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>{values.preferred_venue}</strong> on{" "}
                    <strong>{ftDate(values.function_date || "")}</strong>
                  </Typography>
                </Box>
              </Paper>
            ) : state.checked && state.availabilty === false ? (
              <Paper
                elevation={0}
                sx={{
                  mt: 2,
                  p: 2,
                  borderRadius: 2,
                  border: 2,
                  borderColor: "error.light",
                  bgcolor: "rgba(211, 47, 47, 0.08)",
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 40,
                    height: 40,
                    borderRadius: "50%",
                    bgcolor: "rgba(211, 47, 47, 0.15)",
                  }}
                >
                  <CancelOutlined sx={{ color: "error.main", fontSize: 24 }} />
                </Box>
                <Box>
                  <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    color={"error.main"}
                  >
                    "Venue Not Available"
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>{values.preferred_venue}</strong> on{" "}
                    <strong>{ftDate(values.function_date || "")}</strong>
                  </Typography>
                </Box>
              </Paper>
            ) : null}
          </Grid>
        </Grid>
      </Dialog>

      {openInventory && (
        <Dialog
          open={true}
          onClose={() => setOpenInventory(null)}
          size={"xl"}
          title="Inventory Report"
        >
          <Inventory
            eventLeadData={openInventory}
            isFromEventLead={true}
            calendarFocusDate={openInventory.function_date ?? undefined}
          />
        </Dialog>
      )}
    </>
  );
};
